import { privateRequest } from "../axios";

export const getActivityLog = async (
  search: string = "", 
  pageNo: number = 1, 
  perPage: number = 10, 
) => {
  try {
    const params: any = { search, pageNo, perPage };

    const response = await privateRequest.get(`/audit-logs`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("API Error in getActivityLog:", error);
    throw error;
  }
};